import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardGuard } from '@pacifico/guards/dashboard.guard';
import { AuthPageComponent } from './pages/auth-page/auth-page.component';
import { ChangePasswordPageComponent } from './pages/change-password-page/change-password-page.component';
import { FirstLoginPageComponent } from './pages/first-login-page/first-login-page.component';
import { RecoveryPasswordPageComponent } from './pages/recovery-password-page/recovery-password-page.component';
import { RequestPaswordPageComponent } from './pages/request-pasword-page/request-pasword-page.component';

const routes: Routes = [
	{
		path: 'login',
		component: AuthPageComponent
	},
	{
		path: 'auth/change-password',
		component: ChangePasswordPageComponent
	},
	{
		path: 'auth/first-login',
		component: FirstLoginPageComponent
	},
	{
		path: 'recoveryPassword',
		component: RecoveryPasswordPageComponent
	},
	{
		path: '',
		canActivate: [DashboardGuard],
		loadChildren: () => import('./pages/dashboard/dashboard.module').then((m) => m.DashboardModule)
	},
	{
		path: 'requestPassword',
		component: RequestPaswordPageComponent
	},

	{ path: '**', pathMatch: 'full', redirectTo: 'login' }
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule {}
